/* Deterministic featured-piece filters, isolated to the homepage section. */
(function () {
  'use strict';

  function init(page) {
    if (page.getAttribute('data-bbn-ready') === 'true') return;
    page.setAttribute('data-bbn-ready', 'true');

    var buttons = page.querySelectorAll('.bbn-chip[data-filter]');
    var products = page.querySelectorAll('.bbn-product[data-category]');
    var count = page.querySelector('.bbn-count');

    function applyFilter(selected) {
      var filter = selected.getAttribute('data-filter');
      var visible = 0;

      Array.prototype.forEach.call(buttons, function (button) {
        var active = button === selected;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      Array.prototype.forEach.call(products, function (product) {
        var show = filter === 'all' || product.getAttribute('data-category') === filter;
        product.hidden = !show;
        if (show) visible += 1;
      });

      if (count) {
        count.textContent = 'Showing ' + visible + ' featured ' + (filter === 'all' ? 'pieces' : filter);
      }
    }

    Array.prototype.forEach.call(buttons, function (button) {
      button.addEventListener('click', function () { applyFilter(button); });
    });

    var active = page.querySelector('.bbn-chip[aria-pressed="true"]') || buttons[0];
    if (active) applyFilter(active);
  }

  function initWithin(root) {
    if (root.matches && root.matches('.bbn-page')) init(root);
    Array.prototype.forEach.call(root.querySelectorAll('.bbn-page'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initWithin(document); }, { once: true });
  } else {
    initWithin(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initWithin(event.target); });
})();
